import {
  paymentType,
  paymentTypeOptions,
  planStatus,
  userType,
} from '../../../../assets/helpers/options';
import { casheaLinkAllowedRoles, salesRoles } from '../../../../assets/helpers/roles';

// Todos los tipos de pago de DATOS DEL PAGO; el filtro siempre parte de aquí.
const allPaymentTypesOptions = [
  ...paymentTypeOptions,
  { name: paymentType?.CASHEA, _id: paymentType?.CASHEA },
  { name: 'Cashea Link', _id: paymentType?.CASHEA_LINK },
];

const casheaAllowedRoles = [
  salesRoles?.SALES_ADMIN,
  salesRoles?.SALES_SUPERVISOR,
  salesRoles?.SALES_HUNTER,
  salesRoles?.SALES_FARMER,
  salesRoles?.SALES_COUNTER,
  salesRoles?.EVENTS,
  salesRoles?.SALES_KEY_ACCOUNTS,
];

// Cashea: solo los roles de casheaAllowedRoles; el counter interno, solo en
// órdenes INCOMPLETO. Cashea Link: casheaLinkAllowedRoles. Se recalcula desde
// la lista completa para que, al cambiar el estado (p. ej. al reactivar), una
// opción oculta antes vuelva a aparecer.
export const getPaymentTypeOptions = ({ role, userType: type, membershipStatus } = {}) => {
  const hidesCashea =
    !casheaAllowedRoles.includes(role) ||
    (role === salesRoles?.SALES_COUNTER &&
      type === userType?.INTERNO &&
      membershipStatus !== planStatus?.INCOMPLETED);
  const hidesCasheaLink = !casheaLinkAllowedRoles.includes(role);

  return allPaymentTypesOptions.filter(
    (option) =>
      !(hidesCashea && option?._id === paymentType?.CASHEA) &&
      !(hidesCasheaLink && option?._id === paymentType?.CASHEA_LINK)
  );
};
